import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SettingsService } from 'src/app/settings/settings.service';;
import { addFechaVencimiento } from '../../add-fecha-vencimiento/add-fecha-vencimiento';
import { AgregarFacturasNomina } from '../../agregar-facturas-nomina/agregar-facturas-nomina';
import { AgregarFacturas } from '../../agregar-facturas/agregar-facturas';
import { AgregarFacturasDialog } from '../../simular-facturas/agregar-facturas-dialog/agregar-facturas-dialog';
import { FacturasDelSii } from '../facturas-del-sii/facturas-del-sii';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CrearSimulacionOnboarding } from 'src/app/onboarding/crear-simulacion/crear-simulacion';


declare var $: any;


@Component({
    selector: 'app-add-factura-info',
    templateUrl: './add-factura-info.html',
    styleUrls: ['./add-factura-info.less'],
    standalone: false
})
export class AddFacturaInfo implements OnInit {


  @Input() id_company:any;
  @Input() parent:any;
  @Input() id_sim:any="";
  @Input() onboarding:boolean=false;
  @Input() sim_manual:boolean=false;

  constructor(public settings: SettingsService, public dialog: MatDialog,public fb:FormBuilder, public snackBar:MatSnackBar, 
    private router:Router, public dialogRef:MatDialogRef<AddFacturaInfo> ) {



    this.id_company = localStorage.getItem('company_id');



   }


  step:any=1;

  ngOnInit() {



  }

  facturas:any[]=[];
  comenzar_simulacion:boolean=false;
  open_agregar_facturas(){
    const dialogRef = this.dialog.open(AgregarFacturas,{
      width: '530px',
      maxWidth: '95vw',
      disableClose: true,
    });

    dialogRef.componentInstance.simulacion_id = "";
    dialogRef.afterClosed().subscribe((result:any) => {
      if(result.length > 0){

        this.comenzar_simulacion = true;
        this.facturas = result;
        this.parent.facturas = this.facturas;
        this.parent.comenzar_simulacion = true;

        this.dialogRef.close();
      }
    });
  }

  open_agregar_facturas_by_nomina(){
    const dialogRef = this.dialog.open(AgregarFacturasNomina,{
      width: '600px',
      maxWidth: '95vw',
      disableClose: true,
      autoFocus:false,
    });
    dialogRef.componentInstance.simulacion_id = "";
    dialogRef.afterClosed().subscribe((result:any) => {
      if(result.length > 0){
        this.comenzar_simulacion = true;
        this.facturas = result;

        this.parent.facturas = this.facturas;
        this.parent.comenzar_simulacion = true;

        this.dialogRef.close();
      }
    });
  }

  facturassii(){

    if(this.sim_manual == true){
      this.dialogRef.close();
      this.parent.facturas_del_sii();
      return;
    }

    if(this.onboarding){
        const dialogRef = this.dialog.open(CrearSimulacionOnboarding,{
          width: "1200px",
          autoFocus: false,
        });

        dialogRef.componentInstance.id_sim = this.id_sim;
        dialogRef.componentInstance.onboarding = this.onboarding


        dialogRef.afterClosed().subscribe((result:any) => {
          console.log("PADRE DE TODOS", result)
          if(result == true){
            this.dialogRef.close(true);
          }
        });
    }else{
      const dialogRef = this.dialog.open(FacturasDelSii,{
        width: '100%',
        height: '90%',
        maxWidth: '100vw',
        maxHeight: '100vh',
        hasBackdrop: false,
        autoFocus: false,
        disableClose: false,
      });

      dialogRef.componentInstance.id_sim = this.id_sim;
      dialogRef.componentInstance.onboarding = this.onboarding


      dialogRef.afterClosed().subscribe((result:any) => {
        console.log("PADRE DE TODOS", result)
        if(result == true){
          this.dialogRef.close(true);
        }
      });
    }

  }

  open_agregar_facturas_dialog(){

    if(this.sim_manual == true){
      this.dialogRef.close();
      this.parent.open_agregar_facturas();
      return;
    }

    const dialogRef = this.dialog.open(AgregarFacturasDialog,{
      width: '600px',
      disableClose: true,
      maxWidth: '95vw',
      autoFocus:false,
    });

    dialogRef.componentInstance.parent = this;
    dialogRef.componentInstance.open_as_dialog = true;
    dialogRef.componentInstance.id_sim = this.id_sim;
    dialogRef.componentInstance.simulacion_id = "";

    dialogRef.afterClosed().subscribe((result:any) => {

      if(result.length > 0){
        const dialogRef2 = this.dialog.open(addFechaVencimiento,{
          width: '530px',
          disableClose: true,
          maxWidth: '95vw',
          autoFocus:false,
        });
    
        dialogRef2.componentInstance.facturas = this.facturas;
        dialogRef2.componentInstance.id_sim = this.id_sim;
        dialogRef2.componentInstance.onboarding = this.onboarding;
        dialogRef2.afterClosed().subscribe((result:any) => {
          console.log("ACA 2", result)
            if(result == true){
              this.dialogRef.close(true);
            }
        });
      }

    });
  }


}